import React from 'react';
import loadable from '@loadable/component';

/* istanbul ignore next */
export default loadable(() => import(/* webpackChunkName: "SignInPage" */ './SignInPage'), {
    fallback: <div />,
});
